import React,{useState} from 'react';

export const CareerModule = (props) => {

    const [showLeft, setShowLeft] = useState(true);

    const schoolList = ["镇海中学","杭州第九中学","衢州二中","源清中学","丽水中学","丽水二中","萧山第十一中学","宁波二中","武义三中","温州龙港高级中学","瑞安市第六中学","……"]

    return(
        <div className="four-career">
            <div className="four-right-top">
                <img src={require('../../../assets/images/career_top.png')}/>
            </div>
            <div className="four-career-tab">
                <div className="four-career-tab-lf fl-lf relative hand" onClick={()=>{setShowLeft(true)}}>
                    <div className="overflow-hidden"><img className="div-img-scale1-1" src={require('../../../assets/images/career_tab_1.png')}/></div>
                    {showLeft ? <img className="absolute" style={{left: 58, bottom: -13}} src={require('../../../assets/images/career_tab_1_1.png')}/> : null }
                </div>
                <div className="four-career-tab-ri fl-ri  relative hand" onClick={()=>{setShowLeft(false)}}>
                    <div className="overflow-hidden"><img className="div-img-scale1-1" src={require('../../../assets/images/career_tab_2.png')}/></div>
                    {showLeft ? null : <img className="absolute" style={{left: 58, bottom: -13}} src={require('../../../assets/images/career_tab_2_1.png')}/>}
                </div>
            </div>
            <div className="four-right-bottom shadow">
                { showLeft ? 
                    <div className="four-career-tab-one">
                        <div className="four-career-tab-one-top">
                            <div className="fs-28">专为高中生提供生涯教育和升学指导的智能学习终端</div>
                            <div className="sub-title fs-18">选大学、找专业、挑职业、 查历年数据统统帮您轻松搞定!</div>
                            <div className="four-career-tab-one-top-btm fs-14">
                                <img src={require('../../../assets/images/career_tab_img_1.png')}/>
                                <div>XX行业是做什么的?发展前景如何？<br/>想从事XX行业，大学需要就读哪些专业才能对口呢？<br/>我选考科目是物理、化学、地理，我符合哪些学校专业的选科要求呢?</div>
                                <div>在“智慧生涯”的帮助下，学生利用课余时间就可以进行生涯规划啦!</div>
                            </div>
                        </div>
                        <div className="four-career-tab-one-btm">
                            <div className="four-career-tab-one-btm-title fs-28">“智慧生涯”系统已覆盖百余所高中</div>
                            <div className="four-career-tab-one-btm-school">
                                {schoolList.map((item,index)=>(<div key={index} className={(index+1) % 3 === 0 ? "word-hover-fs-20" : "word-hover-fs-20 mr-38"}>{item}</div>))}
                            </div>
                        </div>
                    </div>
                : 
                    <div className="four-career-tab-two">
                        <div className="title">高中生生涯档案管理系统四大功能</div>
                        <div className="item-wrapper fl-lf mb-55">
                            <div className="item-title">职业指导</div>
                            <div className="item-desc">在线查询高校库、专业库、历年高考大数据、大学排名、专业排名等信息，辅助高中生选择大学专业及合适的职业。</div>
                        </div>
                        <div className="item-wrapper fl-ri mb-55">
                            <div className="item-title">活动课程</div>
                            <div className="item-desc">学生可以图文的形式在线提交社会实践、高校参访、社团活动等等活动的心得体会，提高学生参与课外活动的积极性，增加学校对学生课外活动的认知度。</div>
                        </div>
                        <img src={require('../../../assets/images/career_tab_img_2.png')}/>
                        <div className="item-wrapper fl-lf">
                            <div className="item-title">学业指导</div>
                            <div className="item-desc">包含三一自招、高职提前、传媒艺考等多元升学途径的相关信息资讯，并提供模拟志愿填报功能，学生可提前设计80个志愿，激励学生为进入自己的理想院校和专业而奋斗。</div>
                        </div>
                        <div className="item-wrapper fl-ri">
                            <div className="item-title">成长档案</div>
                            <div className="item-desc">学生可在线进行天赋测评，系统将保留每个学生的天赋测评报告单;学生和家长可在线查询学生各科成绩，并进行自我评估和家长评估。</div>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default CareerModule;